import {apiV2Link} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {IRecommendedProperty} from "../../property/types/IRecommendedProperty";

interface IRecommendedPropertyQueryParams {
    propertyId: number;
    excludedOfferIds: number[];
    page_size: number;
    exclude_grouped: number;
    max_price?: string;
}

interface IRecommendedPropertiesResponse {
    count: number;
    results: IRecommendedProperty[];
}

export const getRecommendedProperties = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getRecommendedProperties: builder.query<IRecommendedPropertiesResponse, IRecommendedPropertyQueryParams>({
            query: (params) => ({
                url: apiV2Link.property.similar({propertyId: params.propertyId}),
                method: "GET",
                params
            })
        })
    })
});

export const {useGetRecommendedPropertiesQuery} = getRecommendedProperties;
